<template>
  <div class="d-flex grey lighten-4 py-3 px-5">
    <v-icon
      left
      color="primary"
      v-text="mdiIcon"
    />
    <span
      style="font-size: 18px"
      v-text="name"
    />
  </div>
</template>

<script>
  export default {
    name: 'NodeTitle',
    props: {
      mdiIcon: {
        type: String,
        default: ''
      },
      name: {
        type: String,
        default: ''
      },
    },
  }
</script>

<style scoped>

</style>
